import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { BaseService } from 'app/@core/services/base.service';
import { IUpdatedPreferenceJson } from 'app/shared/interfaces/companyData.interface';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, of } from 'rxjs';
import { catchError, finalize, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CustomerLoginResolver  {
  constructor(private baseService: BaseService, private spinner: NgxSpinnerService, private router: Router) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IUpdatedPreferenceJson | null> {
    let company = route.paramMap.get('company');
    //  let nickname = route.paramMap.get('nickname');
    const isLogout = new URLSearchParams(window.location.search).get('isLogout');
    const isResetToDefault = new URLSearchParams(window.location.search).get('resetToDefault');
    if (isLogout || isResetToDefault) {
      localStorage.clear();
    }
    if (!company) {
      // if nothing in route, fallback to subdomain
      const host = window.location.hostname;
      if (host.split('.').length > 2) {
        company = host.split('.')[0];
      }
    }
    const apiUrl = `company/GetComapnyPrefrences?company=${company}`;
    this.spinner.show(undefined,
      {
        type: 'ball-scale-multiple',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      }
    );

    return this.baseService.getRequest(apiUrl).pipe(
      map((res: any) => Array.isArray(res) ? res[0] : res),
      tap((res: IUpdatedPreferenceJson) => {
        // If the response is 200, but Login access and Shipment tracking both are false, navigate to not-found page.
        if (!(res.isLoginAccess || res.isEztrackLoginAccess) && !res.isShipmentTracking) {
          this.router.navigate(['/not-found']);
        }
      }),
      finalize(() => this.spinner.hide()),
      catchError(() => {
        // In case of error (response 404), also navigate to not-found page.
        this.router.navigate(['/not-found']);
        return of(null);
      })
    );

  }
}


